import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RequestResponseStatusEnum } from '@shared/enum/request-response-status.enum';
import { StatusRequestEnum } from '@shared/enum/status-request.enum';

@Component({
  selector: 'app-response-list-card',
  templateUrl: './response-list-card.component.html',
  styleUrls: ['./response-list-card.component.scss']
})
export class ResponseListCardComponent implements OnInit {
  requestId;
  @Input() customsIRRPrice: any;
  @Input() destinationInfo: any;
  @Input() goodNames: any;
  @Input() createdDate: string;
  @Input() responseId: number;
  @Input() expiryDate: any;
  @Input() originationInfo: any;
  @Input() providerInfo: any;
  @Input() requestResponseStatus: any;
  @Input() requestStatus: any;
  @Input() serviceIRRPrice: any;
  @Input() transports: any;

  EXPIRED = StatusRequestEnum.EXPIRED;
  PENDING = StatusRequestEnum.PENDING;
  IN_PROGRESS = StatusRequestEnum.IN_PROGRESS;
  CLOSED = StatusRequestEnum.CLOSED;
  IN_CONTRACT = StatusRequestEnum.IN_CONTRACT;
  IS_EXTENDABLE = StatusRequestEnum.IS_EXTENDABLE;

  pending = RequestResponseStatusEnum.PENDING;
  REJECTED = RequestResponseStatusEnum.REJECTED;
  ANSWERED = RequestResponseStatusEnum.ANSWERED;
  ACCEPTED = RequestResponseStatusEnum.ACCEPTED;
  CANCELED = RequestResponseStatusEnum.CANCELED;
  expired = RequestResponseStatusEnum.EXPIRED;
  cloesed = RequestResponseStatusEnum.CLOSED;

  constructor(public router: Router) { }

  ngOnInit(): void {
    this.requestId = localStorage.getItem('requestId');
  }
}
